export const isFinanceAccount = account =>
  String(account?.email || '').trim().toLowerCase() === 'finacc@iskhouse.id';

export const currentAccount = () => {
  try { return JSON.parse(localStorage.getItem('owner') || 'null'); }
  catch { return null; }
};
